// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase:{
    apiKey: 'AIzaSyCecvPN0hjV5g6Xkkr4Co8vn7P26bR1vq8',
    authDomain: 'bessalel-795bb.firebaseapp.com',
    databaseURL: 'https://bessalel-795bb.firebaseio.com',
    projectId: 'bessalel-795bb',
    storageBucket: 'bessalel-795bb.appspot.com',
    messagingSenderId: '757170849965',
    appId: '1:757170849965:web:c351ac941d16b51c01de24'
   // measurementId: “from firebase config”
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
